import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import Listar from '../../../../components/auth/balanco/listar'


function ListarBalancoScreen() {

    return (
        <Fragment>
            <Head titulo="Balanços Cadastrados - Módulo de Balanços" />
            <HeaderLogged />
            <Container>
               <Listar />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ListarBalancoScreen;